import Auth from "../Auth";
import Model from "./Model";

import Document from "./Document";
import Team from "./Team";
import ProjectPosition from "./ProjectPosition";
import Project from "./Project";
import Client from "./Client";

import User from "./User";
import TalentCandidate from "./TalentCandidate";
import UserDiscipline from "./UserDiscipline";

import IsOpportunityTraits from "./decorators/IsOpportunityTraits"

const OpportunityStatus = {
    Interested: 'Shown Interest',
    Invited: 'Invited',
    AwaitingTeamApproval: 'Awaiting Team Approval',
    Proposing: 'Proposing',
    PendingContract: 'Pending Contract',
    Active: 'Active',
    Lost: 'Lost',
    Declined: 'Declined',
    Complete: 'Complete',
    Withdrawn: 'Withdrawn',
    // Cancelled: 'Cancelled',
}

const ProjectType = {
    Service: 'Service-Based',
    BYO: 'Build Your Own',
}


// "status": "Shown Interest",
//     "can_be_accepted": false,
//     "can_be_rejected": false,
//     "can_be_withdrawn": false,
//     "is_dead": false,
//     "is_for_client_engagement_lead": false,
//     "is_for_team": false,
//     "documents_count": 0,
//      "estimated_payout_amount": 0,
//     "accepted_at": null,
//     "rejected_at": null,
//     "withdrew_at": null,
//     "legal_terms": "The client has chosen to manage the project team themselves.",
//     "has_signable_contract": false,
//     "signed_contract_at": null,
//     "created_at": "2021-11-16T20:11:10.000000Z",
//     "last_viewed_at": "2022-09-11T17:42:58.000000Z",
//     "last_viewed_brief_at": null,
//     "accepted_client_project_overview_at": null,
//     "accepted_role_skills_at": null,
//     "accepted_schedule_at": null,
//     "accepted_payout_at": null,
// talent_uploaded_proposals: []
// disciplines: []
// job_candidate": {
//           "id": 1782,
//           "confirmed_started_at": null,
//           "confirmed_ended_at": null,
//           "unread_messages_count": 0,
//           "requested_meetings_count": 4,
//           "upcoming_meetings_count": 1,
//           "pending_confirmed_meetings_count": 1,
//           "proposed_meetings_count": 1,
//           "cover_letter": null,
//           "relevant_experience": null,
//           "original_rate": 85,
//           "hourly_rate": 85,
//           "premarkup_cost": 0,
//           "confirmed_avg_hours_per_period": null,
//           "talent_invited_at": null,
//           "talent_accepted_at": null,
//           "talent_rejected_at": null,
//           "talent_withdrew_at": null,
//           "talent_proposed_at": null,
//           "latest_meeting_update_at": "2022-09-09T15:27:21.000000Z",
//           "latest_message_at": "2022-09-09T15:27:21.000000Z"
//         },
// project_position: {
// "id": 2726,
//     "title": "Copywriter",
//     "started_at": "2021-11-15T00:00:00.000000Z",
//     "ended_at": "2021-12-20T05:00:00.000000Z",
//     "avg_hours_per_period": 30,
//     "posted_at": null,
//     "is_new": true,
//     "market_rate": 80,
//     "description": null,
//     "description_path": null,
//     "required_onsite": false,
//     "onsite_days_per_week": null,
//     "is_contract_to_hire": false,
//     "total_weeks": 6,
//     "total_hours": 180,
//     "min_score": 4,
// "is_match": true,
//           "has_shown_interest_in_job": true,
// matching:
//
// }
export default class Opportunity extends IsOpportunityTraits(Model)
{
    static Statuses = OpportunityStatus;

    static Tabs = null;

    static Key = 'Opportunity';

    static async cancelSearchKeywords()
    {
        if (this.SearchKeywordsRequest && !this.SearchKeywordsRequest.didFinish) {
            await this.SearchKeywordsRequest.cancel();
        }
    }

    static async searchKeywords(query)
    {
        await this.cancelSearchKeywords();

        let user = Auth.registeredTalentUser();
        if (!user || !user.canManageTalent()) {
            return;
        }

        this.SearchKeywordsRequest = TB.request(
            TB.api_endpoint(`/api/talent-user-opportunities/keywords/search`), {
                search: query
            });

        let response = await this.SearchKeywordsRequest.get().catch(console.warn);
        if (!response && this.SearchKeywordsRequest.wasCancelled) {
            return;
        }

        if (!response || !TB.has(response, 'success.data.results')) {

            let didHandleError = await this.SearchKeywordsRequest.handleError();
            if (didHandleError
                && this.SearchKeywordsRequest.shouldRerun) {
                return this.searchKeywords(query);
            }

            return false
        }

        return [...response.success.data.results];
    }

    static FetchAllForTalentManagerRequest;

    static async fetchAllForTalentManager(params = {}, refresh = true)
    {
        // console.log('fetchAllForTalentManager');
        let user = Auth.registeredTalentUser();
        if (!user || !user.canManageTalent()) {
            return;
        }

        // console.log(params);

        let formattedParams = {};
        for (let [key,value] of Object.entries(params)) {
            if (TB.isArray(value)) {
                if (!value.length) {
                    continue;
                }
                value = value.join(',');
            }
            formattedParams[key] = value;
        }


        await this.cancelRequest('FetchAllForTalentManagerRequest')
        // console.log(formattedParams);
        this.FetchAllForTalentManagerRequest = TB.request(
            TB.api_endpoint(`/api/talent-user-opportunities`),
            formattedParams
        );

        let request = this.FetchAllForTalentManagerRequest;
        let response = await request.get().catch(console.warn);

        if (request.wasCancelled) {
            return;
        }

        if (!response || !TB.has(response, 'success.data.opportunities')) {
            return TB.event("Opportunities@FetchForTalentManagerFailed", this.FetchAllForTalentManagerRequest)
        }

        let {
            opportunities,
            current_page,
            last_page,
            total
        } = response.success.data;

        let models = this.makeMany([...opportunities]);

        let statusOptions = Opportunity.statusOptions();

        models = TB.orderBy(
            models,
            opp => statusOptions.indexOf(opp.display_status),
            'asc'
        );

        TB.event("Opportunities@FetchForTalentManagerUpdated",
            {
                models,
                current_page,
                last_page,
                total
            }
        )
    }

    static async fetchAllForTalent(requestOptions = {})
    {
        let user = Auth.registeredTalentUser();

        if (!user) {
            return;
        }
        this.FetchAllRequest = TB.request(
            TB.api_endpoint(`/api/talent-user-opportunities`)
        );

        let response = await this.FetchAllRequest.get(requestOptions).catch(console.warn);

        if (!TB.has(response, 'success.data.opportunities')) {
            return;
        }

        return this.makeMany([...response.success.data.opportunities]);
    }

    static async fetchForTalent(oppId, requestOptions = {})
    {
        let user = Auth.registeredTalentUser();
        // let projects = [];
        if (!user || !oppId) {
            throw new Error("Unauthorized")
        }

            this.FetchRequest = TB.request(
                TB.api_endpoint(`/api/talent-user-opportunities/${oppId}`)
            );

            let response = await this.FetchRequest.get(requestOptions).catch(console.warn);

            if (!TB.has(response, 'success.data.opportunity')) {
                throw new Error("Unable to load opportunity")
            }

        return this.make(response.success.data.opportunity);
    }

    static SyncRequest;

    async update(props)
    {
        this.constructor.cancelRequest('SyncRequest');

        this.constructor.SyncRequest = TB.request(
            TB.api_endpoint(
                `/api/talent-user-opportunities/${this.id}/update`
            ), props
        );

        if (TB.filter(TB.values(props), value => value instanceof File).length) {
            this.constructor.SyncRequest = this.constructor.SyncRequest.headers({
                'Content-Type': 'multipart/form-data'
            })
        }
        let response = await this.constructor.SyncRequest.post().catch(e => {
            console.warn("UPDATE", e)
        });

        if (!TB.has(response, 'success.data.opportunity')) {
            throw new Error("Something went wrong")
        }

        let opportunity = this.constructor.make(response.success.data.opportunity);

        return opportunity;
    }


    static AcceptOppRequest;

    static async acceptOpportunity(opportunity, params)
    {
        if (!opportunity.can_be_accepted) {
            throw new Error("Opportunity cannot be accepted")
        }

        this.AcceptOppRequest = TB.request(
            TB.api_endpoint(
                `/api/talent-user-opportunities/${opportunity.id}/accept`
            ), params
        );

        let response = await this.AcceptOppRequest.post().catch(e => {
            console.warn("UPDATE", e)
        });

        if (!TB.has(response, 'success.data.opportunity')) {
            throw new Error("Something went wrong")
        }

        let updatedOpp = this.make(response.success.data.opportunity);
        if (!updatedOpp.is_agency_opp) {
            await Opportunity.refreshCacheFor(
                updatedOpp
            );
        }
        return updatedOpp
    }
    static RejectOppRequest;

    static async rejectOpportunity(opportunity, params)
    {
        if (!opportunity.can_be_rejected) {
            throw new Error("Opportunity cannot be rejected")
        }
        this.RejectOppRequest = TB.request(
            TB.api_endpoint(
                `/api/talent-user-opportunities/${opportunity.id}/reject`
            ), params
        );

        let response = await this.RejectOppRequest.post().catch(e => {
            console.warn("UPDATE", e)
        });

        if (!TB.has(response, 'success.data.opportunity')) {
            throw new Error("Something went wrong")
        }

        let updatedOpp = this.make(response.success.data.opportunity);
        if (!updatedOpp.is_agency_opp) {
            await Opportunity.refreshCacheFor(
                updatedOpp
            );
        }
        return updatedOpp
    }
    static WithdrawOppRequest;

    static async withdrawOpportunity(opportunity, params)
    {
        console.log('Opportunity @ withdrawOpportunity', opportunity, params)
        if (!opportunity.can_be_withdrawn) {
            throw new Error("Opportunity cannot be withdrawn")
        }
        this.WithdrawOppRequest = TB.request(
            TB.api_endpoint(
                `/api/talent-user-opportunities/${opportunity.id}/withdraw`
            ), params
        );

        let response = await this.WithdrawOppRequest.post().catch(e => {
            console.warn("UPDATE", e)
        });

        if (!TB.has(response, 'success.data.opportunity')) {
            throw new Error("Something went wrong")
        }

        let updatedOpp = this.make(response.success.data.opportunity);
        if (!updatedOpp.is_agency_opp) {
            await Opportunity.refreshCacheFor(
                updatedOpp
            );
        }
        return updatedOpp
    }

    static async submitSatisfactionSurveyOpp(oppId, data) {
        this.submitSatisfactionSurveyOppRequest = TB.request(
            TB.api_endpoint(`/api/talent-user-opportunities/${oppId}/platform-surveys/store`),
            data,
        );

        let response = await this.submitSatisfactionSurveyOppRequest.post().catch(e => console.warn(e));

        console.log(response,' RESPONSE FROM SERVER')

        if (!TB.has(response || {}, 'success.data')) {
            throw new Error("Something went wrong")
        }
        if (!response.success.data.platform_survey) {
            throw new Error("Something went wrong")
        }
   
        return true
    }

    static ReminderRequest;

    async sendRemindToAccept() {
        this.constructor.cancelRequest('ReminderRequest');

        this.constructor.ReminderRequest = TB.request(
            TB.api_endpoint(
                `/api/talent-user-opportunities/${this.id}/send-accept-reminder`
            )
        );

        let response = await this.constructor.ReminderRequest.post().catch(e => {
            console.warn("UPDATE", e)
        });

        if (!TB.has(response, 'success')) {
            throw new Error('Something went wrong');
        }
        return Opportunity.make({
            ...this,
            can_remind_to_accept:  false,
            reminded_to_accept_at: new Date()
        })
    }

    async remindMember(member)
    {
        let members = this.teamMembers();

        let memberIndex = TB.findIndex(members, ['id', member.id])

        if (members[memberIndex] && members[memberIndex]?.talent_opp_id && members[memberIndex].can_remind_to_accept) {
            this.constructor.cancelRequest('ReminderRequest');

            this.constructor.ReminderRequest = TB.request(
                TB.api_endpoint(
                    `/api/talent-user-opportunities/${members[memberIndex]?.talent_opp_id}/send-accept-reminder`
                )
            );

            let response = await this.constructor.ReminderRequest.post().catch(e => {
                console.warn("UPDATE", e)
            });

            if (!TB.has(response, 'success')) {
                return;
            }
            members[memberIndex].can_remind_to_accept = false;
            members[memberIndex].reminded_to_accept_at = new Date();

            let team = this.team ?  {...this.team, members: [...members]} : undefined

            let opportunity = this.constructor.make({...this, team});

            await Opportunity.refreshCacheFor(
                opportunity
            );

            return opportunity;
        }
    }


    alertForMissingSections() {
        return TB.sysAlert('talent.accept_opportunity_brief_required');
    }

    static FetchDocumentsRequest;

    async fetchDocuments()
    {
        this.constructor.cancelRequest('FetchDocumentsRequest');

        this.constructor.FetchDocumentsRequest = TB.request(
            TB.api_endpoint(
                `/api/talent-user-opportunities/${this.id}/get-documents`
            )
        );

        let response = await this.constructor.FetchDocumentsRequest.get().catch(e => {
            console.warn("FetchDocumentsRequest", e)
        });

        if (!TB.has(response, 'success.data.documents')) {
            return [];
        }

        return Document.makeMany([...response.success.data.documents]);
    }

    static UploadDocumentsRequest;

    static async uploadForOpportunity(opportunity, props)
    {
        this.UploadDocumentsRequest = TB.request(
            TB.api_endpoint(
                `api/talent-user-opportunities/${opportunity.id}/documents/create`
            ),
            {...props}
        );

        this.UploadDocumentsRequest = this.UploadDocumentsRequest.headers({
            'Content-Type': 'multipart/form-data',
        });

        let response = await this.UploadDocumentsRequest.post().catch(console.warn);

        if (!TB.has(response, 'success.data.document'))
        {
            let didHandleError = await this.UploadDocumentsRequest.handleError();
            if (didHandleError
                && this.UploadDocumentsRequest.shouldRerun) {
                return this.uploadForOpportunity(opportunity, props);
            }

            return;
        }

        let newDocument = this.make(response.success.data.document);

        opportunity = Opportunity.make({...opportunity});
        opportunity.documents.push({...newDocument});

        Opportunity.refreshCacheFor(opportunity);

        return newDocument;
    }

    static DeleteDocumentRequest;

    async deleteDocument(doc, prop = 'talent_uploaded_proposals')
    {
        let docs = TB.flatten([this[prop]]);

        if (!TB.find(docs, ['id', doc.id])) {
            return false;
        }

        this.DeleteDocumentRequest = TB.request(
            TB.api_endpoint(
                `/api/talent-user-opportunities/${this.id}/documents/${doc.id}/delete`
            )
        );

        let response = await this.DeleteDocumentRequest.post().catch(console.warn);

        if (!TB.has(response, 'success'))
        {
            let didHandleError = await this.DeleteDocumentRequest.handleError();
            if (didHandleError
                && this.DeleteDocumentRequest.shouldRerun) {
                return this.deleteDocument(doc);
            }

            return false;
        }

        if (TB.isArray(this[prop])) {
            docs = TB.reject(docs, ['id', doc.id]);
        }else docs = null;

        let opportunity = Opportunity.make({...this, [prop]: docs});

        Opportunity.refreshCacheFor(opportunity);

        return opportunity;
    }

    async withdrawInterest(updateCallback)
    {

        if (this.withdrew_at) {
            return false;
        }

        let shouldWithdrawForTeam = this.canAdmin()
            && this.canWithdrawForTeam();

        let shouldWithdraw = await TB.sysAlert(
            shouldWithdrawForTeam
                ? 'talent.opportunity_withdraw_as_admin_btn_click'
                : 'talent.opportunity_withdraw_btn_click'
        )

        if (!shouldWithdraw) {
            return false;
        }

        let params = {}

        params.withdrew_at = new Date();
        if (shouldWithdrawForTeam) {
            params.withdrew_for_team_at = new Date();
        }

        let didUpdate = await updateCallback(params);

        await Opportunity.withdrawOpportunity(this)
        if (!didUpdate) {
            return false;
        }

        if (shouldWithdrawForTeam) {
            await TB.sysAlert('talent.opportunity_withdrawn_for_team');
        }

        return true;
    }

    static normalize(props)
    {
        props.display_status = this.displayStatusFor(props.status, props);

        if (props.project_position) {
            props.project_position = ProjectPosition.make({
                ...props.project_position,
                type: props.project.type,
                contract_type: props.project.contract_type
            });

            if (props.project?.positions?.length) {
                props.project.positions = TB.map([...props.project.positions], position => {
                    if (position.id === props.project_position.id) {
                        return {
                            ...position,
                            assigned: {
                                user: {...(TB.auth().user() || {})},
                                disciplines: position.disciplines
                            }
                        };
                    }
                    return position
                })
            }
        }

        if (props.team) {
            props.team = Team.make({...props.team})
        }
        if (props.talent_user) {
            props.talent_user = User.make({...props.talent_user})
        }
        if (props.project?.team) {
            props.project.team = Team.make({...props.project.team})
        }

        if (props.project) {
            props.project = Project.make({...props.project})
        }
        if (props.client) {
            props.client = Client.make({...props.client})
        }

        if (props.latest_contract) {
            props.latest_contract = Document.make({...props.latest_contract})
        }

        if (props.latest_signed_contract) {
            props.latest_signed_contract = Document.make({...props.latest_signed_contract})
        }

        if (props.latest_proposal) {
            props.latest_proposal = Document.make({...props.latest_proposal})
        }
        if (props.talent_uploaded_proposals) {
            props.talent_uploaded_proposals = Document.makeMany([...props.talent_uploaded_proposals])
        }

        if (props.disciplines?.length > 0) {
            if (props.is_for_team && props.project?.phases?.length) {
                props.disciplines = TB.map(props.disciplines, discipline => {
                    let deliverableActivities = discipline.deliverable_activities || [];
                    let deliverables = TB.flatMap(props.project.phases, 'deliverables');

                    deliverables = TB.reduce(deliverables, (delResults, deliverable) => {
                        let activities = TB.reduce(deliverable.activities, (actResults, act) => {
                            if (TB.find(deliverableActivities, ['id', act.id])) {
                                actResults.push(TB.find(deliverableActivities, ['id', act.id]))
                            }
                            return actResults;
                        }, []);
                        if (activities?.length > 0) {
                            delResults.push({
                                ...deliverable,
                                activities,
                                total_hours: TB.sumBy(activities, 'total_hours')
                            })
                        }
                        return delResults;
                    }, []);
                    return {
                        ...discipline,
                        deliverables
                    }
                })
            }
            props.disciplines = UserDiscipline.makeMany(props.disciplines)
        }

        if(props.job_candidate) {
            let candidate = props.job_candidate;

            if (props.is_fixed_fee_contract && candidate.talent_opps?.length) {
                candidate.talent_opps = TB.map(candidate.talent_opps, opp => {
                    let has_accepted_proposed_payout = true;
                    if (opp.hourly_rate && candidate.original_rate !== opp.hourly_rate) {
                        has_accepted_proposed_payout = false
                    }
                    TB.map(opp.position_deliverables, del => {
                        let matchedDel = TB.find(props.project_position?.deliverables, ['id', del.id]);
                        if (matchedDel && matchedDel.total_hours !== del.total_hours) {
                            has_accepted_proposed_payout = false
                        }
                    })
                    return {
                        ...opp,
                        has_accepted_proposed_payout
                    }
                })
            }
            props.job_candidate = TalentCandidate.make({...candidate})

        }
        return props;
    }

    hasCompletedCoverLetter() {
        return this.job_candidate?.cover_letter && TB.stripHtml(this.job_candidate?.cover_letter)?.length > 0
    }

    detailLink(step = this.currentProjectStep()) {

        let path = `/talent/project/${this.id}`;

        if (step && step.path) {
            path += step.path;
        }

        return path;
    }

    proposalLink() {
        return `/talent/project/${this.id}/proposal`
    }

    statusColor()
    {
        if (!this.id) {
            return this.is_match ? TB.config('color.success') : TB.config('color.warning')
        }
        switch (this.status) {
            case OpportunityStatus.Invited:
            case OpportunityStatus.Proposing:
            case OpportunityStatus.AwaitingTeamApproval:
            case OpportunityStatus.PendingContract:
                if (this.project.is_on_hold) {
                    return TB.config('color.disabled')
                }
                break;
        }

        return Opportunity.colorForStatus(this.status);
    }

    statusClass()
    {
        return Opportunity.classForStatus(this.status);
    }

    static colorForStatus(status) {

        switch (status) {

            case OpportunityStatus.Invited:
            case 'Invited (new)':
            case OpportunityStatus.Proposing:
            case OpportunityStatus.AwaitingTeamApproval:
            // case OpportunityStatus.PendingLost:
                return TB.config('color.purple');
            case OpportunityStatus.PendingContract:
                return TB.config('color.black');
            case OpportunityStatus.Interested:
            case OpportunityStatus.Active:
                return TB.config('color.green');

            case OpportunityStatus.Lost:
            case OpportunityStatus.Declined:
            case OpportunityStatus.Withdrawn:
            case 'Lost / Declined':
                return TB.config('color.red');

            case OpportunityStatus.Complete:
                return TB.config('color.black');
        }
    }

    static classForStatus(status)
    {
        let color = this.colorForStatus(status);
        let sClass = 'primary';
        switch (color) {
            case 'purple':
            case TB.config('color.purple'):
                sClass = "primary";
                break;
            case 'orange':
                sClass = "warning";
                break;
            case 'blue':
                sClass = "info";
                break;
            case 'red':
            case TB.config('color.red'):
                sClass = "danger";
                break;
            case 'green':
            case TB.config('color.green'):
                sClass = "success";
                break;
            case 'black':
            case TB.config('color.black'):
                sClass = "dark";
                break;
        }

        return sClass;
    }
}
const updateOpportunity = async(opportunity,props) => {
    return opportunity.update(props)
}
const acceptOpportunity = async(opportunity, props = {}) => {
    return Opportunity.acceptOpportunity(opportunity, props)
}
const rejectOpportunity = async(opportunity, props) => {
    return Opportunity.rejectOpportunity(opportunity, props)
}
const withdrawOpportunity = async(opportunity, props = {}) => {
    return Opportunity.withdrawOpportunity(opportunity, props)
}

export {
    updateOpportunity,
    acceptOpportunity,
    rejectOpportunity,
    withdrawOpportunity
}